import { Observable } from 'rxjs';
import { $httpClient } from '@/services/httpClient';
import {
  CREATE_MESSAGE,
  DELETE_MESSAGES, GET_MESSAGES_ALL_OFFICE_LIST,
  GET_MESSAGES_BY_CUSTOMER,
  UPDATE_MESSAGE,
} from '@/types/backoffice/messages.types';
import { BackofficeMessageModel } from '@/models/BackofficeMessage.model';
import { BaseResponse } from '@/models/response/base/BaseResponse';
import { DeleteRemindersRequest } from '@/models/backoffice/DeleteRemindersRequest';
import { GridResponse } from '@/models/response/base/GridResponse';
import { OfficesModel } from '@/models/Offices.model';
import { GET_ALL_OFFICES_BY_CUSTOMER } from '@/types/customer.types';

export default class MessagesService {
  private readonly baseApi: string;
  private readonly messagesBaseApi: string;

  constructor() {
    this.baseApi = 'api/bo/';
    this.messagesBaseApi = this.baseApi + 'messages/';
  }

  public getMessagesByCustomer(indexNum): Observable<{ employerMessages: BackofficeMessageModel[] }> {
    return $httpClient.get<{ employerMessages: BackofficeMessageModel[] }>(this.messagesBaseApi
      + GET_MESSAGES_BY_CUSTOMER + '?indexNum=' + indexNum);
  }

  public getAllOfficesByCustomer(indexNum: number): Observable<GridResponse<OfficesModel>> {
    return $httpClient.get<GridResponse<OfficesModel>>(this.messagesBaseApi +
      GET_MESSAGES_ALL_OFFICE_LIST + '?indexNum=' + indexNum);
  }

  public createMessage(message: BackofficeMessageModel): Observable<BaseResponse> {
    return $httpClient.post<BaseResponse>(this.messagesBaseApi + CREATE_MESSAGE, message);
  }

  public updateMessage(messageToUpdate: BackofficeMessageModel): Observable<boolean> {
    return $httpClient.post<boolean>(this.messagesBaseApi + UPDATE_MESSAGE, messageToUpdate);
  }

  public deleteMessages(messagesToDelete: DeleteRemindersRequest): Observable<boolean> {
    return $httpClient.post<boolean>(this.messagesBaseApi + DELETE_MESSAGES, messagesToDelete);
  }

  // public getCustomerDetails(indexNum: number): Observable<CustomerDetailsModel> {
  //   return $httpClient.get<CustomerDetailsModel>(this.customerBaseApi +
  //   GET_CUSTOMER_DETAILS + '?indexNum=' + indexNum);
  // }
  //
  // public updateCustomer(CustomerDetailsAsCustomerModel: CustomerDetailsModel): Observable<AxiosResponse> {
  //   return $httpClient.put(this.customerBaseApi + UPDATE_CUSTOMER, CustomerDetailsAsCustomerModel);
  // }
  //
  // public getAllOfficesByCustomer(indexNum: number): Observable<GridResponse<OfficesModel>> {
  //   return $httpClient.get<GridResponse<OfficesModel>>(this.customerBaseApi +
  //     GET_ALL_OFFICES_BY_CUSTOMER + '?indexNum=' + indexNum);
  // }
  //
  // public getOfficeDetails(indexNum: number, officeNum: number): Observable<CustomerDetailsModel> {
  //   return $httpClient.get<CustomerDetailsModel>(this.customerBaseApi + GET_OFFICE_DETAILS +
  //     '?indexNum=' + indexNum + '&officeNum=' + officeNum);
  // }
  //
  // public updateOffice(data: CustomerDetailsModel): Observable<BaseResponse> {
  //   return $httpClient.post<BaseResponse>(this.customerBaseApi + UPDATE_OFFICE, data);
  // }
  //
  // public getAllRemindersByCustomer(indexNum: number): Observable<GridResponse<OfficesModel>> {
  //   return $httpClient.get<GridResponse<OfficesModel>>(this.remindersBaseApi +
  //     GET_ALL_REMINDERS_BY_CUSTOMER + '?indexNum=' + indexNum);
  // }
  //
  // public createReminders(createReminders: CreateRemindersRequest): Observable<CreateMailReminderModel> {
  //   return $httpClient.post<CreateMailReminderModel>(this.remindersBaseApi + CREATE_REMINDERS, createReminders);
  // }
  //
  // public deleteReminders(deleteRemindersRequest: DeleteRemindersRequest): Observable<any> {
  //   return $httpClient.post<any>(this.remindersBaseApi + DELETE_REMINDERS, deleteRemindersRequest);
  // }
  //
  // public getManagersByCustomer(indexNum: number): Observable<GridResponse<ManagerPrivilegesModel>> {
  //   return $httpClient.get<GridResponse<ManagerPrivilegesModel>>(this.managersBaseApi +
  //     GET_MANAGERS_BY_CUSTOMER + '?indexNum=' + indexNum);
  // }
  //
  // public searchManager(searchManagerRequest: SearchManagerRequest): Observable<SearchManagerModel> {
  //   return $httpClient.post<SearchManagerModel>(this.managersBaseApi + SEARCH_MANAGER, searchManagerRequest);
  // }
  //
  // public createManager(managerPrivilegesModel: CreateManagerPrivilegesModel): Observable<BaseResponse> {
  //   return $httpClient.post<BaseResponse>(this.managersBaseApi + CREATE_MANAGER, managerPrivilegesModel);
  // }
  //
  // public deleteManager(managerToDelete: ManagerPrivilegesRequest): Observable<boolean> {
  //   return $httpClient.post<boolean>(this.managersBaseApi + DELETE_MANAGER, managerToDelete);
  // }
  //
  // public listOrgUnits(indexNum: number): Observable<GridResponse<ManagerPrivilegesModel>> {
  //   return $httpClient.get<GridResponse<ManagerPrivilegesModel>>(this.managersBaseApi +
  //     GET_MANAGERS_BY_CUSTOMER + '?indexNum=' + indexNum);
  // }
  //
  // public getManagerPrivileges(managerToUpdate: ManagerPrivilegesRequest):
  //   Observable<GridResponse<ManagerPrivilegesModel>> {
  //   return $httpClient.post<GridResponse<ManagerPrivilegesModel>>(this.managersBaseApi +
  //     GET_MANAGER_PRIVILEGES, { indexNum: managerToUpdate.indexNum, id: managerToUpdate.id });
  // }
  //
  // public updateManagerPrivileges(managerToUpdate: ManagerPrivilegesRequest):
  //   Observable<GridResponse<ManagerPrivilegesModel>> {
  //   return $httpClient.post<GridResponse<ManagerPrivilegesModel>>(this.managersBaseApi +
  //     UPDATE_MANAGER, managerToUpdate);
  // }
  //
  // public getOrganisationUnitsList(organisationUnitsRequest: OrganisationUnitsRequestModel):
  //   Observable<GridResponse<ManagerPrivilegesModel>> {
  //   return $httpClient.post<GridResponse<ManagerPrivilegesModel>>(this.managersBaseApi +
  //     LIST_ORG_UNITS, organisationUnitsRequest);
  // }

}
